import React, { useEffect } from 'react'
import { Button, Input, Textarea } from '../../../../Components/StyledComponents';
import './CreateMenuGroup.scss';
import {cloneDeep} from 'lodash-es';

const ModifyMenuGroup = ({info,modifyMenuGroup}) => {
    const [ name, setName ] = React.useState('')
    const [ desc, setDesc ] = React.useState('')

    useEffect(() => {
        if(typeof info !== 'undefined'){
            setName(cloneDeep(info.Name))
            setDesc(cloneDeep(info.Description))
        }
    },[])

    const patch = () => {
        modifyMenuGroup({
            Name : name,
            Description : desc,
            GroupId : info._id.$oid
        })
    }

    return (
        <div className='create-menu'>
            <div className='row'>
                <p className='label'>메뉴그룹명</p>
                <Input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={{ width : 347 }}
                    placeholder="예) 메인메뉴, 세트메뉴 등"
                />
            </div>

            <div className='row' style={{ alignItems : 'flex-start', marginTop : 16 }}>
                <p className='label'>설명(선택)</p>
                <Textarea
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                    style={{ width : 347, height : 173 }}
                    placeholder="예) 세트 구성 메뉴입니다."
                />
            </div>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()} disabled={ name.trim() === ''}>
                    수정하기
                </Button>
            </div>
        </div>
    )
}

export default ModifyMenuGroup;